import React from "react"
import styled from "styled-components"
import { ConfigFormList } from "./config_form_list"
import { SelectCalendarDropdownForm } from "../../common/components/select_calendar_dropdown"
import { appStrings } from "../../common/strings/app_strings"
import { TagCalendarEdit } from "../tag_google_config_select"
import { DefaultDescriptionField } from "./default_description_field"
import { KeywordTagMatchingController } from "./keyword_tag_matching_controller"
import { AttendeeUserMatchingController } from "./attendee_user_matching_controller"
import { CalendarBooleanField } from "./calendar_boolean_field"
import { colors } from "../../common/colors/app_colors"
import { makeToast } from "../../util/toast_util"
import { GOOGLE_CALENDAR_INTEGRATION_URL } from "../../common/constants/app_consts"
const {
    connectedCalendars,
    connectedAccounts,
    allDayEventsLabel,
    createForMembersLabel,
    createForMembersDetail,
    googleCalendarOverview,
} = appStrings.connectedApps
const { iconGray } = colors

const TrashButton = ({ handleClick }) => {
    return (
        <div className="trash-button" onClick={handleClick}>
            <i className="fa fa-trash-o" aria-hidden="true"></i>
            <span>Delete configuration</span>
        </div>
    )
}

export const GoogleCalendarConfigForm = ({
    profile,
    config,
    handleStartGoogleOauth,
    removeAccount,
    removeCalendar,
    handleSetDescription,
    handleUpdateTagKeywords,
    teams,
    team,
    handleUpdateConfigTags,
    selectCalendar,
    tags,
    handleUpdateAttendeeUsers,
    handleUpdateCreateAllDayRecords,
    handleUpdateCreateRecordsForMembers,
    handleDeleteConfig,
}) => {
    const {
        gCalendarSubscriptions,
        gCalendarAccounts: googleAccounts,
        id,
        defaultDescription,
        availableCalendars,
        tagKeywords,
    } = config
    const { id: currentUserId, personalTeamId } = profile
    const hasAccounts = !!googleAccounts.length
    const hasCalendarSubscriptions = !!gCalendarSubscriptions.length
    const isSharedTeam = !team.isPersonal

    const handleDelete = () => {
        const toastMsg = `Are you sure you want to delete this Google Calendar Configuration? Time records will no longer be created automatically based on this config. ${isSharedTeam ? "As a shared team, this action may impact other team members." : ""}`
        const deleteConfig = () => {
            handleDeleteConfig(id)
        }
        const action = {
            text: "YES",
            onClick: deleteConfig,
        }
        makeToast(toastMsg, "danger", action)
    }
    return (
        <ConfigFormWrapper>
            {googleAccounts.length < 1 && (
                <div>
                    {googleCalendarOverview}
                    To learn more, click <a className="a-button"
                        href={GOOGLE_CALENDAR_INTEGRATION_URL}
                        target="_blank">here.</a>
                </div>
            )}
            <ConfigFormList
                title={connectedAccounts}
                currentUserId={currentUserId}
                listItems={googleAccounts}
                isAccount={true}
                config={config}
                handleStartGoogleOauth={handleStartGoogleOauth}
                removeAccount={removeAccount}
            />
            {hasAccounts && (
                <div>
                    <ConfigFormList
                        title={connectedCalendars}
                        currentUserId={currentUserId}
                        listItems={gCalendarSubscriptions}
                        isAccount={false}
                        config={config}
                        removeCalendar={removeCalendar}
                    />
                    <SelectCalendarDropdownForm
                        availableCalendars={availableCalendars}
                        selectCalendar={selectCalendar}
                        gCalendarSubscriptions={gCalendarSubscriptions}
                    ></SelectCalendarDropdownForm>
                </div>
            )}
            {hasCalendarSubscriptions ? (
                <div>
                    <DefaultDescriptionField
                        configId={id}
                        defaultDescription={defaultDescription}
                        handleSetDescription={handleSetDescription}
                    />
                    <TagCalendarEdit
                        team={team}
                        teams={teams}
                        config={config}
                        tags={tags}
                        profile={profile}
                        handleUpdateConfigTags={handleUpdateConfigTags}
                    />
                    <KeywordTagMatchingController
                        handleUpdateTagKeywords={handleUpdateTagKeywords}
                        configId={id}
                        teams={teams}
                        tagKeywords={tagKeywords}
                        personalTeamId={personalTeamId}
                        team={team}
                        tags={tags}
                        teamId={config.teamId}
                    />
                    {isSharedTeam && (
                        <CalendarBooleanField
                            value={config.createRecordsForMembers}
                            handleChecked={handleUpdateCreateRecordsForMembers}
                            configId={id}
                            label={createForMembersLabel}
                            detail={createForMembersDetail}
                        />
                    )}
                    {isSharedTeam && (<AttendeeUserMatchingController
                        attendeeUsers={config.attendeeUsers}
                        configId={id}
                        configMembers={config.members}
                        handleUpdateAttendeeUsers={handleUpdateAttendeeUsers}
                    />)}
                    <div className="final-row">
                        <CalendarBooleanField
                            configId={id}
                            value={config.createAllDayRecords}
                            handleChecked={handleUpdateCreateAllDayRecords}
                            label={allDayEventsLabel}
                        />
                    </div>
                    <TrashButton handleClick={handleDelete} />
                </div>
            ) : <TrashButton handleClick={handleDelete} />
            }

        </ConfigFormWrapper>
    )
}

const ConfigFormWrapper = styled.div`
    width: 100%;
    .final-row {
        display: flex;
        justify-content: space-between;
    }
    .trash-button {
        font-size: 24px;
        cursor: pointer;
        i {
            margin-left: -3px;
            color: ${iconGray};
        }
        :hover {
            color: black;
        }
        span {
            font-family: inherit;
            font-size: 14px;
            font-weight: 600;
            padding-left: 8px;
        }
    }
    .team-info {
        display: flex;
        flex-direction: column;
    }
    .name {
        font-family: rubik, sans-serif;
        font-weight: 600;
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/google_calendar_config_form.jsx